import { call } from 'redux-saga/effects';
import { customBackgroundDeleted } from 'features/virtual-backgrounds/virtualBackgroundsSlice';
import { SignalingSocket } from 'services/signaling';

export function* deletePersistedBackgroundSaga(action: ReturnType<typeof customBackgroundDeleted>) {
  if (action.payload.persisted) {
    yield call(SignalingSocket.send, {
      event: 'deleteVirtualBackground',
      data: { id: action.payload.id },
    });
  }
}
